import React from "react";



const CreditUsageTable = ({ creditUsageData }: any) => {

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6">
      {/* Header */}
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Credit Usage by Plan</h2>

      <div className="overflow-x-auto">
        <table className="w-full text-sm text-gray-700 border-collapse">
          <thead>
            <tr className="border-b border-gray-200 text-left text-gray-500">
              <th className="py-3 px-4 font-medium">Plan Type</th>
              <th className="py-3 px-4 font-medium">Active Employers</th>
              <th className="py-3 px-4 font-medium">Total Credits</th>
              <th className="py-3 px-4 font-medium">Used Credits</th>
              <th className="py-3 px-4 font-medium">Avg. Utilization</th>
              <th className="py-3 px-4 font-medium">Credits Expiring ( 7 days )</th>
            </tr>
          </thead>

          <tbody>
            {creditUsageData?.map((item:any, index:any) => (
              <tr
                key={item.planType}
                className={`hover:bg-gray-50 ${
                  index % 2 === 1 ? "bg-gray-50/50" : "bg-white"
                } border-b last:border-0`}
              >
                {/* Plan Type */}
                <td className="py-3 px-4">
                  <span
                    className={`px-3 py-1 text-xs font-semibold rounded-full border
                      ${
                        item.planType === "MONTHLY"
                          ? "text-blue-700 border-blue-400 bg-blue-50"
                          : item.planType === "SINGLE PLAN"
                          ? "text-purple-700 border-purple-400 bg-purple-50"
                          : item.planType.includes("ANNUAL FLEX")
                          ? "text-indigo-700 border-indigo-400 bg-indigo-50"
                          : item.planType === "CUSTOM ANNUAL"
                          ? "text-green-700 border-green-400 bg-green-50"
                          : "text-gray-600 border-gray-300 bg-gray-50"
                      }`}
                  >
                    {item.planType}
                  </span>
                </td>

                {/* Active Employers */}
                <td className="py-3 px-4 font-medium text-gray-900">{item.activeEmployers}</td>

                {/* Total Credits */}
                <td className="py-3 px-4">{item.totalCredits}</td>

                {/* Used Credits */}
                <td className="py-3 px-4">{item.usedCredits}</td>

               

                {/* Avg Utilization */}
                <td className="py-3 px-4">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-gray-900">{item.avgUtilization}%</span>
                    <div className="relative w-[100px] h-2 bg-gray-100 rounded-full overflow-hidden">
                      <div
                        className="absolute left-0 top-0 h-full bg-[#1E596D] transition-all duration-300"
                        style={{ width: `${item.avgUtilization}%` }}
                      ></div>
                    </div>
                  </div>
                </td>

                {/* Credits Expiring Soon */}
                <td className="py-3 px-4">
                  <span
                    className={"font-medium text-gray-900"  }
                  >
                    {item.creditsExpiringSoon}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CreditUsageTable;
